<template>
  <div>
    <page-title :title="title"></page-title>
    <construction></construction>
  </div>
</template>

<script>
  import Construction from '@/components/Construction'
  import PageTitle from '@/components/PageTitle'
  export default {
    name: 'current',
    data () {
      return {
        title: 'Current projects'
      }
    },
    components: {
      Construction,
      PageTitle
    }
  }
</script>

<styles>

</styles>



// WEBPACK FOOTER //
// Current.vue?6f7d998b